import { api } from "services/restUtil";
import { ResolvedPreferences, UpdatePreferencesArgs } from "./tools";

export function createTallyConversation(
  offer: RTCSessionDescriptionInit
): Promise<Response> {
  return api.post<string | undefined, Response>("/tally/conversations", offer.sdp, {
    headers: {
      "Content-Type": "application/sdp",
      Accept: "application/sdp",
    },
    rawResponse: true,
  });
}

export async function updateTallyPreferences(args: UpdatePreferencesArgs) {
  return api.post<UpdatePreferencesArgs, ResolvedPreferences>("/tally/preferences", args);
}
